import gql from 'graphql-tag';

import conversationUserPromptFragment from './conversationUserPromptFragment';
import dokkioObjectDokkioTagFragment from './dokkioObjectDokkioTagFragment';
import embeddedDokkioTagFragment from './embeddedDokkioTagFragment';
import taskFragment from './taskFragment';

export const conversationFragment = gql`
  fragment conversationFragment on Conversation {
    dokkioClass
    id
    accountID
    remoteConversationID
    name
    rowCreatedAt
    isTextLoadingComplete
    summary
    conversationOrigin
    conversationUserPrompts {
      ...conversationUserPromptFragment
    }
    dokkioTags {
      ...embeddedDokkioTagFragment
    }
    dokkioObjectDokkioTags {
      ...dokkioObjectDokkioTagFragment
    }
    dokkioTagIDs
    tasks {
      ...taskFragment
    }
  }
  ${conversationUserPromptFragment}
  ${dokkioObjectDokkioTagFragment}
  ${embeddedDokkioTagFragment}
  ${taskFragment}
`;
export default conversationFragment;
